module.exports = "<div>\r\n    <span class=\"text\">{{text}}</span>\r\n  </div>\r\n  <img src=\"./assets/snackBar_warning.svg\" class=\"tick ml-2\">\r\n  "